import React, { useState } from "react";
import cn from "classnames";

const ArrowIcon = () => (
  <svg width="45" height="45" viewBox="0 0 45 45" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="22.5" cy="22.5" r="22.5" fill="#F0F7FB" />
    <path
      d="M21.4348 28.3984L13.9348 20.8984C13.427 20.4297 13.427 19.6094 13.9348 19.1406C14.4036 18.6328 15.2239 18.6328 15.6926 19.1406L22.3333 25.7422L28.9348 19.1406C29.4036 18.6328 30.2239 18.6328 30.6926 19.1406C31.2004 19.6094 31.2004 20.4297 30.6926 20.8984L23.1926 28.3984C22.7239 28.9062 21.9036 28.9062 21.4348 28.3984Z"
      fill="#0077C0"
    />
  </svg>
);

export const Collapse = ({ title, description }) => {
  const [active, setActive] = useState(false);

  return (
    <div
      className={cn("group rounded-lg bg-white border border-gray-modern-300 py-4 px-6", {
        active,
      })}
    >
      <div
        className="flex items-center justify-between gap-2 cursor-pointer"
        onClick={() => setActive(!active)}
      >
        <span className="text-gray-modern-800 font-bold text-text-md">{title}</span>
        <div className="group-[.active]:rotate-180 transition-all">
          <ArrowIcon />
        </div>
      </div>
      <div className="grid-rows-[0fr] transition-all grid group-[.active]:grid-rows-[1fr]">
        <div className="overflow-hidden">
          <div
            className="flex flex-col gap-3 pt-6 text-primary-900 text-text-sm lg:text-text-xs"
            dangerouslySetInnerHTML={{
              __html: description,
            }}
          />
        </div>
      </div>
    </div>
  );
};
